/*
 * @Author: lbb lhz6887@163.com
 * @Date: 2024-06-29 09:18:43
 * @LastEditors: lbb lhz6887@163.com
 * @LastEditTime: 2024-07-09 15:49:42
 * @FilePath: \YHB_H5\src\utils\core.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
    Toast
} from "vant";
import Compressor from 'compressorjs';
/**
 * @desc 函数防抖
 * @param func 目标函数
 * @param wait 延迟执行毫秒数
 * @param immediate true - 立即执行， false - 延迟执行
 */
export const debounce = function(func, wait = 1000, immediate = true) {
	let timer;
	return function() {
		
		let context = this,
			args = arguments;
		if (timer) clearTimeout(timer);
		if (immediate) {
			let callNow = !timer;
			timer = setTimeout(() => {
				timer = null;
			}, wait);
			if (callNow) func.apply(context, args);
			else {
				Toast('请稍等...');
			}
		} else {
			timer = setTimeout(() => {
				func.apply(context, args);
			}, wait)
		}
	}
}
/**
 * @desc 函数节流
 * @param func 函数
 * @param wait 延迟执行毫秒数
 * @param type 1 使用表时间戳，在时间段开始的时候触发 2 使用表定时器，在时间段结束的时候触发
 */
export const throttle = (func, wait = 1000, type = 1) => {
	let previous = 0;
	let timeout;
	return function() {
		let context = this;
		let args = arguments;
		if (type === 1) {
			let now = Date.now();

			if (now - previous > wait) {
				func.apply(context, args);
				previous = now;
			}
		} else if (type === 2) {
			if (!timeout) {
				timeout = setTimeout(() => {
					timeout = null;
					func.apply(context, args)
				}, wait)
			}
		}
	}
}

/**
 * @desc 日期格式化
 * @param dateStr 日期字符串
 * @param format 格式
 */
export const formatDateTime = (dateStr, format) => {
	var d = new Date(dateStr.replace(/-/g, '/'));
	
    var map = {
        'yyyy': d.getFullYear(),
        'mm': ("0" + (d.getMonth() + 1)).slice(-2),
        'dd': ("0" + d.getDate()).slice(-2),
        'hh': ("0" + d.getHours()).slice(-2),
        'mi': ("0" + d.getMinutes()).slice(-2),
        'ss': ("0" + d.getSeconds()).slice(-2)
    };

    return format.replace(/yyyy|mm|dd|hh|mi|ss/gi, function(matched) {
        return map[matched];
    });
}

/**
 * @desc 日期格式
 * @param val 时间
 * @param fmt 日期格式 yyyy-MM-dd hh:mm:ss
 */
export const dateFormat = (val, fmt = 'yyyy-MM-dd') => { //时间
	if (!val) {
		return '';
	}
	var date = val === 'default' ? new Date() : new Date(val);
	let nowDate = {
		yyyy: date.getFullYear(), // 年
		MM: date.getMonth() + 1, // 月份
		dd: date.getDate(), //日
		hh: date.getHours(),
		mm: date.getMinutes(),
		ss: date.getSeconds()
	}
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	for (var k in nowDate) {
		if (new RegExp("(" + k + ")").test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (nowDate[k]) : (("00" + nowDate[k]).substr(("" +
				nowDate[k]).length)));
		}
	}
	return fmt;
};


//  判断对象是否有为空的属性
export function objIsNull (obj, arr = []) {
	for (let key in obj) {
		// 检查该属性是否在要忽略的属性列表中
        if (arr.includes(key)) {
            continue; // 忽略该属性
        }
		if (obj.hasOwnProperty(key) && (obj[key] === null || obj[key] === undefined || obj[key] === "")) {
			console.log("为空的key", key);
			return false; // 如果找到为空的属性，返回 false
		}
	}
	return true; // 如果没有找到为空的属性，返回true
}

/**
   * 图片压缩
   * @param {File} image 图片
   * @param {String} backType 需要返回的类型blob、file
   * @param {Number} quality 图片压缩比，数字越小，图片压缩越小
   * @return
   */
export function compressorImage(image, backType, quality) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-new
      new Compressor(image, {
        quality: quality || 0.8,
        success(result) {
          if (!backType || backType === 'blob') {
            resolve(result);
          } else if (backType === 'file') {
            const file = new File([result], image.name, { type: image.type });
            resolve(file);
          }  else if (backType === 'base64') {
            const reader = new FileReader();
            reader.readAsDataURL(result);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
          }
        },
        error(err) {
          reject(err);
        }
      });
    });
  }
